import gql from 'graphql-tag';

export const CreatePasswordChangeTicketUrl = gql`
  mutation CreatePasswordChangeTicketUrl($organizationId: ID!) {
    createPasswordChangeTicketUrl(organizationId: $organizationId)
  }
`;
